const systemField = {
    dateTimeFromFilename: 'DateTime_From_Filename',
    fileNameFromFile: 'FileName_From_File'
};

export default systemField;
